import React, { ComponentProps } from "react";
import { TargetPageType, WideImageModel } from "../Models/PageCreatorPage";

type ImageWrapperProps = ComponentProps<"a"> & {
  children: React.ReactNode;
  image: WideImageModel;
};

const WideImageWrapper = ({ image, children, ...props }: ImageWrapperProps) => {
  // If targetPageType null then always fall back to default behavior of rendering a link
  if (
    image.targetPageType &&
    image.targetPageType === TargetPageType.NoTargetPage
  ) {
    return (
      <span
        className={props.className}
        key={image.imageAltText}
        data-testid="wide-image-wrapper-non-link"
      >
        {children}
      </span>
    );
  }

  return (
    <a
      href={image.targetUrl}
      className={props.className}
      key={image.imageAltText}
      data-testid="wide-image-wrapper-link"
    >
      {children}
    </a>
  );
};

export default WideImageWrapper;
